import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("e") || "";
  const token = params.get("t") || "";
  const [state, setState] = useState("loading"); // loading | done | error | resubscribed
  const [busy, setBusy] = useState(false);

  const run = useCallback(async () => {
    if (!email || !token) return setState("error");
    try {
      await api.post("/unsubscribe", { email, token });
      setState("done");
    } catch {
      setState("error");
    }
  }, [email, token]);

  useEffect(() => { run(); }, [run]);

  const resubscribe = async () => {
    setBusy(true);
    try {
      await api.post("/resubscribe", { email, token });
      setState("resubscribed");
    } catch {
      /* ignore */
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#090909] text-[#F2EFEB] flex items-center justify-center px-6" data-testid="unsubscribe-page">
      <div className="max-w-md w-full border-2 border-[#F2EFEB]/30 p-8">
        <p className="font-mono-ui text-xs uppercase tracking-[0.3em] text-[#DFFF00] mb-6">GOOD GRIEF WORLDWIDE</p>

        {state === "loading" && <p className="animate-pulse opacity-70">Updating your preferences…</p>}

        {state === "error" && (
          <>
            <h1 className="font-display text-3xl uppercase mb-3">Link expired</h1>
            <p className="opacity-70 text-sm">This unsubscribe link isn’t valid. If you keep getting emails you don’t want, reply to any email and we’ll sort it out.</p>
          </>
        )}

        {state === "done" && (
          <>
            <h1 className="font-display text-3xl uppercase mb-3" data-testid="unsub-done">You’re unsubscribed</h1>
            <p className="opacity-70 text-sm mb-6">{email} won’t receive any more GOOD GRIEF broadcast emails. Order and shipping updates for purchases still send as normal.</p>
            <button onClick={resubscribe} disabled={busy} data-testid="resubscribe-btn" className="h-11 px-5 border-2 border-[#DFFF00] text-[#DFFF00] uppercase text-xs tracking-widest hover:bg-[#DFFF00] hover:text-[#090909] transition-colors disabled:opacity-50">
              {busy ? "…" : "Changed your mind? Resubscribe"}
            </button>
          </>
        )}

        {state === "resubscribed" && (
          <>
            <h1 className="font-display text-3xl uppercase mb-3" data-testid="resub-done">You’re back on the list</h1>
            <p className="opacity-70 text-sm">{email} will hear about the next drop. Grief incoming.</p>
          </>
        )}
      </div>
    </main>
  );
}
